/* SHOPYTHON enquiry — chips, hidden fields, WhatsApp prefill.

   Split out of scroll-film.js so /pages/contact can load it too. The film engine
   cannot run there: it grabs #frames straight away and would throw on a page with
   no canvas, killing everything after it. This file touches nothing but the form.

   On the homepage scroll-film.js calls window.SF_ENQ.preselect() and .setLine()
   when the finder produces a line, so the customer never answers the same
   question twice and the WhatsApp message carries the spec. */
(function () {
  "use strict";
  if (window.__sfEnq) return;
  window.__sfEnq = true;

  var form = document.getElementById('enq');
  if (!form) return;

  var WA = window.SF_WA || '60178056033';
  var eq = {};
  var LINE = null;   // {out, sum, open} from the finder, or null off the homepage

  function money(n) { return 'RM ' + Math.round(n).toLocaleString('en-MY'); }

  function write(g, v) {
    eq[g] = v || '';
    var h = document.getElementById('eq-' + g);
    if (h) h.value = eq[g];
    sync();
  }

  /* The chips carry type="button" in the snippet: a bare <button> inside a form
     submits it. Scoped to [data-eq] so the homepage finder's own .q blocks,
     which use the same .opt styling, never write into this state. */
  document.querySelectorAll('.q[data-eq]').forEach(function (q) {
    q.addEventListener('click', function (e) {
      var b = e.target.closest('.opt');
      if (!b) return;
      q.querySelectorAll('.opt').forEach(function (o) { o.classList.toggle('on', o === b); });
      write(q.dataset.eq, b.dataset.v);
    });
  });

  function preselect(g, v) {
    var q = document.querySelector('.q[data-eq="' + g + '"]'), hit = false;
    if (!q || !v) return;
    q.querySelectorAll('.opt').forEach(function (o) {
      var on = o.dataset.v === v;
      o.classList.toggle('on', on);
      if (on) hit = true;
    });
    if (hit) write(g, v);
  }

  /* One structured message instead of "Hi, I want to enquire." Sales can size the
     lead before replying. */
  function sync() {
    var msg = ['Hi SHOPYTHON, I need help choosing bakery equipment.', ''];
    if (eq.product) msg.push('Product: ' + eq.product);
    if (eq.output) msg.push('Daily output: ' + eq.output);
    if (eq.goal) msg.push('Problem: ' + eq.goal);

    var flat = '';
    if (LINE) {
      var rows = LINE.out.map(function (m) {
        return m.k + ' — ' + m.n + ' — ' + (m.p === null ? 'ask us' : money(m.p));
      });
      flat = rows.join(' | ');
      msg.push('', 'Line your site suggested:');
      rows.forEach(function (r) { msg.push('• ' + r); });
      msg.push('Indicative ' + (LINE.open ? 'from ' : 'total ') + money(LINE.sum));
    }

    var h = document.getElementById('eq-line');
    if (h) h.value = flat;

    var a = document.getElementById('wa');
    if (a) a.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(msg.join('\n'));
  }

  window.SF_ENQ = {
    preselect: preselect,
    setLine: function (l) { LINE = l; sync(); }
  };

  sync();
})();
